import Vue from 'vue';
import VueRouter from 'vue-router';
import Dashboard from '@/components/Dashboard'
import Report from '@/components/Report'
import StudentsReport from '@/components/StudentsReport'
import AddHomework from '@/components/AddHomework'
import BadGateway from '@/components/BadGateway'
import EditPlan from '@/components/EditPlan'
import AddPlan from '@/components/AddPlan'
import Plans from '@/components/Plans'
import Students from '@/components/Students'
import PendingStudents from '@/components/PendingStudents'
import Payments from '@/components/Payments'
import Homeworks from '@/components/Homeworks'
import Login from '@/components/Login'
import BroadcastAdmin from '@/components/BroadcastAdmin'
import AddAvatars from '@/components/AddAvatars'
import Avatars from '@/components/Avatars'


Vue.use(VueRouter);

const router = new VueRouter({
    mode: 'history',
    routes: [{
            path: '/login',
            name: 'Login',
            props: { page: 5 },
            component: Login
        },
        {
            path: '/dashboard',
            name: 'Dashboard',
            component: Dashboard,
            props: { page: 1 },
            alias: '/',
            meta: { requiresAuthAdmin: true },

        },
        {
            path: '/report',
            name: 'Report',
            component: Report,
            props: { page: 2 },
            meta: { requiresAuthAdmin: true },
        },

        {
            path: '/missions/:parent',
            name: 'Homeworks',
            props: { page: 2 },
            component: Homeworks,
            meta: { requiresAuthAdmin: true },
        },

        {
            path: '/admin-broadcast',
            name: 'BroadcastAdmin',
            props: { page: 2 },
            component: BroadcastAdmin,
            meta: { requiresAuthAdmin: true },
        },

        {
            path: '/students',
            name: 'Students',
            props: { page: 2 },
            component: Students,
            meta: { requiresAuthAdmin: true },
        },
        {
            path: '/pending-students',
            name: 'PendingStudents',
            props: { page: 2 },
            component: PendingStudents,
            meta: { requiresAuthAdmin: true },
        },
        {
            path: '/students-report',
            name: 'StudentsReport',
            props: { page: 2 },
            component: StudentsReport,
            meta: { requiresAuthAdmin: true },
        },

        {
            path: '/add-homework/:levelId',
            name: 'AddHomework',
            props: { page: 3 },
            component: AddHomework,
            meta: { requiresAuthAdmin: true },
        },

        {
            path: '/plans',
            name: 'Plans',
            props: { page: 3 },
            component: Plans,
            meta: { requiresAuthAdmin: true },
        },
        {
            path: '/payments',
            name: 'Payments',
            props: { page: 3 },
            component: Payments,
            meta: { requiresAuthAdmin: true },
        },
        {
            path: '/add-plan',
            name: 'AddPlan',
            props: { page: 4 },
            component: AddPlan,
            meta: { requiresAuthAdmin: true },
        },

        {
            path: '/404',
            name: 'BadGateway',
            props: { page: 5 },
            component: BadGateway,
        },
        {
            path: '*',
            props: { page: 5 },
            redirect: '/404'
        },
        {
            path: '/home',
            props: { page: 5 },
            redirect: '/dashboard',
            meta: { requiresAuthAdmin: true },
        },
        {
            path: '/edit-plan/:planId',
            name: 'EditPlan',
            props: { page: 8 },
            component: EditPlan,
            meta: { requiresAuthAdmin: true },
        },
        {
            path: '/avatarassets',
            name: 'AvatarAssets',
            props: { page: 3 },
            component: Avatars,
            meta: { requiresAuthAdmin: true },
        },
        {
            path: '/add-avatarassets',
            name: 'AddAvatarAssets',
            props: { page: 4 },
            component: AddAvatars,
            meta: { requiresAuthAdmin: true },
        },

    ],

})

router.beforeEach((to, from, next) => {
    if (to.matched.some(record => record.meta.requiresAuthAdmin)) {
        if (!localStorage.getItem('fastAdminToken')) {
            next({
                name: "Login"
            })
        } else {
            next();
        }
    } else {
        next();
    }

    if (to.matched.some(record => record.meta.requiresAuthTeacher)) {
        if (!localStorage.getItem('fastTeacherToken')) {
            next({
                name: "LoginTeacher"
            })
        } else {
            next();
        }
    } else {
        next();
    }


})

export default router